import request from '@/utils/request'
import { listFrom } from '@/utils/ledger'

export const getChartOfAccounts = params => request.get('/accounting/chart-of-accounts', { params })

export const getChartOfAccountsTree = params => request.get('/accounting/chart-of-accounts/tree', { params })

export const getChartOfAccount = id => request.get(`/accounting/chart-of-accounts/${id}`)

export const createChartOfAccount = data => request.post('/accounting/chart-of-accounts', data)

export const updateChartOfAccount = (id, data) => request.put(`/accounting/chart-of-accounts/${id}`, data)

export const deleteChartOfAccount = id => request.delete(`/accounting/chart-of-accounts/${id}`)

export async function fetchAllChartAccounts(params = {}) {
  const perPage = params.per_page || 100
  const first = await getChartOfAccounts({ ...params, per_page: perPage, page: 1 })
  const rows = listFrom(first)
  const lastPage = Number(first?.meta?.last_page) || 1
  for (let page = 2; page <= lastPage; page += 1) {
    const res = await getChartOfAccounts({ ...params, per_page: perPage, page })
    rows.push(...listFrom(res))
  }
  return rows
}
